module.exports = __webpack_public_path__ + "img/a02.45b20486.svg";